// Panier flottant — le pendant JS de sections/MM-Cart-Drawer.liquid.
//
// INTERFACE OPTIMISTE. L'ancienne version attendait la réponse du serveur
// pour bouger quoi que ce soit : 300 à 800ms d'immobilité perçus comme un
// freeze. Ici chaque clic met l'interface à jour immédiatement — quantité,
// prix de ligne, total, compteurs, bascule de la livraison offerte, retrait
// d'une ligne — à partir des data-qty / data-unit-price portés par les
// lignes. Le serveur confirme derrière : le HTML frais de la section
// (API Section Rendering) remplace le bloc entier, et comme l'optimiste a
// déjà affiché le même état, la correction est invisible.
//
// Garde-fou de séquence : chaque requête prend un numéro ; seule la réponse
// de la DERNIÈRE requête a le droit de remplacer le bloc — une réponse en
// retard sur des clics rapides ne peut pas écraser un état plus récent.
// Les rafales de +/- sont regroupées : 280ms sans clic → une seule requête
// avec la quantité finale.
(function () {
	var isOpen = false;
	var seq = 0;          // numéro de la dernière requête partie
	var addSeq = 0;       // numéro pris par l'ajout en cours
	var timers = {};      // débounce par clé de ligne

	function root() {
		return document.querySelector('[data-mm-cart]');
	}
	function sectionId() {
		var r = root();
		return r ? r.getAttribute('data-section-id') : null;
	}

	/* ---------- ouverture / fermeture ---------- */

	function apply() {
		var r = root();
		if (!r) return;
		r.classList.toggle('is-open', isOpen);
		var pill = r.querySelector('[data-mm-cart-toggle]');
		if (pill) {
			pill.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
			/* Volet ouvert, la pilule passe en opacity 0 derrière le voile —
			   mais elle restait un arrêt de tabulation : le premier Tab partait
			   sur un bouton invisible. On la sort de l'ordre par tabindex plutôt
			   que par visibility en CSS, pour ne pas toucher à son fondu de
			   sortie (les durées diffèrent entre les deux points de rupture).
			   close() repasse par apply() AVANT de refocaliser la pilule, elle
			   est donc redevenue une cible valide à ce moment-là. WCAG 2.4.3. */
			if (isOpen) {
				pill.setAttribute('tabindex', '-1');
			} else {
				pill.removeAttribute('tabindex');
			}
		}
		var panel = r.querySelector('[data-mm-cart-panel]');
		if (panel) {
			/* aria-modal seulement pendant l'ouverture : le volet vit en
			   permanence dans le DOM, un aria-modal figé ferait taire le reste
			   de la page pour les lecteurs d'écran. */
			if (isOpen) {
				panel.setAttribute('aria-modal', 'true');
			} else {
				panel.removeAttribute('aria-modal');
			}
		}
		syncPill();
	}

	/* En mobile la pilule vit DANS la rangée de nav : la barre doit lui
	   laisser exactement sa place. On la mesure (le compteur fait varier sa
	   largeur) et la barre se raccourcit d'autant via --mm-cart-pill-w. */
	function syncPill() {
		var r = root();
		if (!r) return;
		document.body.classList.add('mm-has-cart');
		var pill = r.querySelector('[data-mm-cart-toggle]');
		if (pill && pill.offsetWidth) {
			document.body.style.setProperty('--mm-cart-pill-w', pill.offsetWidth + 'px');
		}
	}

	function open() {
		if (isOpen || !root()) return;
		isOpen = true;
		apply();
		var panel = root().querySelector('[data-mm-cart-panel]');
		if (panel) panel.focus({ preventScroll: true });
	}

	function close() {
		if (!isOpen) return;
		isOpen = false;
		apply();
		var pill = root() && root().querySelector('[data-mm-cart-toggle]');
		if (pill) pill.focus({ preventScroll: true });
	}

	/* ---------- synchronisation serveur ---------- */

	/* Le bloc entier est remplacé par le HTML frais du serveur. Sans ce relevé,
	   un utilisateur au clavier qui vient d'appuyer sur « + » voit son focus
	   retomber sur <body> 300ms plus tard, sans rien pour le prévenir. On note
	   la ligne (data-key) et le rôle du bouton, on le repose sur son jumeau du
	   bloc frais. Aucun effet à la souris : le navigateur ne rallume
	   :focus-visible que si le focus précédent l'était déjà. WCAG 2.4.3. */
	var CIBLES_FOCUS = [
		'data-mm-cart-minus',
		'data-mm-cart-plus',
		'data-mm-cart-remove',
		'data-mm-cart-close',
		'data-mm-cart-toggle',
		'data-mm-cart-panel'
	];

	function releverFocus(r) {
		var el = document.activeElement;
		if (!el || !r.contains(el)) return null;
		for (var i = 0; i < CIBLES_FOCUS.length; i++) {
			if (el.hasAttribute(CIBLES_FOCUS[i])) {
				var ligne = el.closest('[data-mm-cart-item]');
				return {
					attr: CIBLES_FOCUS[i],
					key: ligne ? ligne.getAttribute('data-key') : null
				};
			}
		}
		/* Repli : le focus était bien dans le bloc remplacé, mais sur une cible
		   hors liste (Commander, le CTA de l'état vide). Sans ce retour, le
		   focus tombait sur <body> au swap serveur et Entrée ne faisait plus
		   rien. Le panneau porte tabindex="-1", il est donc hors anneau. */
		return { attr: 'data-mm-cart-panel', key: null };
	}

	function reposerFocus(next, releve) {
		if (!releve) return;
		var portee = next;
		if (releve.key) {
			portee = next.querySelector('[data-mm-cart-item][data-key="' + releve.key.replace(/"/g, '\\"') + '"]');
		}
		var cible = portee && portee.querySelector('[' + releve.attr + ']');
		// la ligne a disparu (retrait, rupture) : on retombe sur le volet
		if (!cible) cible = next.querySelector('[data-mm-cart-panel]');
		if (cible) cible.focus({ preventScroll: true });
	}

	function swap(html) {
		var r = root();
		if (!r || !html) return;
		var doc = new DOMParser().parseFromString(html, 'text/html');
		var next = doc.querySelector('[data-mm-cart]');
		if (!next) return;
		var releve = releverFocus(r);
		r.replaceWith(next);
		apply(); // repose is-open et aria sur le bloc frais
		reposerFocus(next, releve);
	}

	function refresh() {
		var id = sectionId();
		if (!id) return Promise.resolve();
		var mySeq = ++seq;
		return fetch(window.location.pathname + '?sections=' + encodeURIComponent(id))
			.then(function (response) { return response.json(); })
			.then(function (data) {
				if (mySeq === seq) swap(data[id]);
			});
	}

	function sendChange(key, quantity) {
		var id = sectionId();
		var mySeq = ++seq;
		fetch('/cart/change.js', {
			method: 'POST',
			headers: { 'Content-Type': 'application/json' },
			body: JSON.stringify({
				id: key,
				quantity: quantity,
				sections: id,
				sections_url: window.location.pathname
			})
		})
			.then(function (response) { return response.json(); })
			.then(function (data) {
				if (mySeq !== seq) return; // une opération plus récente est partie
				/* Refus du serveur (stock insuffisant surtout) : on resynchronise,
				   PUIS on dit pourquoi — swap() remplace le volet, un message posé
				   avant serait effacé. */
				if (data.status && data.status !== 200) {
					var msg = data.description || data.message || ERREUR_PANIER;
					return refresh().then(function () { erreur(msg); });
				}
				if (data.sections && data.sections[id]) {
					swap(data.sections[id]);
				} else {
					return refresh();
				}
			})
			.catch(function (error) {
				console.error('Erreur panier :', error);
				refresh().then(function () { erreur(ERREUR_PANIER); });
			});
	}

	function scheduleChange(key, quantity) {
		clearTimeout(timers[key]);
		timers[key] = setTimeout(function () {
			delete timers[key];
			sendChange(key, quantity);
		}, 280);
	}

	/* ---------- mise à jour optimiste ---------- */

	var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

	function money(cents) {
		return (cents / 100).toLocaleString('fr-FR', {
			minimumFractionDigits: 2,
			maximumFractionDigits: 2
		});
	}

	function numval(s) {
		return parseFloat(String(s).replace(/\s/g, '').replace(',', '.')) || 0;
	}

	/* ---------- erreur visible ---------- */
	var ERREUR_PANIER = "La quantité n'a pas pu être mise à jour. Réessayez ou contactez-nous.";
	function erreur(texte) {
		var r = root();
		var el = r && r.querySelector('[data-mm-cart-erreur]');
		if (!el) return;
		el.textContent = '';
		if (texte) el.textContent = texte;
	}

	/* ---------- annonces ---------- */
	/* La seule sortie parlée du volet. Sans elle, « Augmenter la quantité » ne
	   renvoie strictement rien : l'interface optimiste réécrit quantité, prix
	   de ligne, total, compteurs et état vide en silence. La région est unique
	   et visually-hidden (MM-Cart-Drawer.liquid), elle ne prend aucune place.
	   WCAG 4.1.3. */
	function annonce(texte) {
		var r = root();
		var el = r && r.querySelector('[data-mm-cart-annonce]');
		if (el) el.textContent = texte;
	}

	function phrasePanier(qty, total) {
		if (qty === 0) return 'Panier vide.';
		return 'Panier, ' + qty + ' article' + (qty > 1 ? 's' : '') + ', total ' + money(total) + ' euros.';
	}

	function synthese() {
		var r = root();
		if (!r) return '';
		var qty = 0;
		var total = 0;
		r.querySelectorAll('[data-mm-cart-item]').forEach(function (row) {
			var q = parseInt(row.getAttribute('data-qty'), 10) || 0;
			qty += q;
			total += q * (parseInt(row.getAttribute('data-unit-price'), 10) || 0);
		});
		return phrasePanier(qty, total);
	}

	// Compteur roulant : l'ancienne valeur sort par le haut pendant que la
	// nouvelle monte du bas (sens inversé quand la valeur baisse) — le même
	// geste vertical que les libellés du menu. dataset.rollTo garde la cible
	// pendant le roulement : des clics rapides repartent de la bonne valeur.
	function roll(el, next) {
		if (!el) return;
		next = String(next);
		var current = el.dataset.rollTo !== undefined ? el.dataset.rollTo : el.textContent.trim();
		if (current === next) return;
		if (reduceMotion.matches) {
			el.textContent = next;
			return;
		}
		var down = numval(next) < numval(current);
		el.dataset.rollTo = next;
		el.classList.add('mm-roll');
		el.classList.toggle('mm-roll--down', down);
		el.innerHTML = '<span class="mm-roll__out">' + current + '</span><span class="mm-roll__in">' + next + '</span>';
		el.classList.remove('is-rolling');
		void el.offsetWidth; /* repeint l'état de départ avant de lancer le trajet */
		el.classList.add('is-rolling');
		clearTimeout(el._rollTimer);
		el._rollTimer = setTimeout(function () {
			el.textContent = next;
			delete el.dataset.rollTo;
			el.classList.remove('is-rolling', 'mm-roll--down', 'mm-roll');
		}, 450);
	}

	// Recalcule compteurs, total et livraison depuis les data des lignes.
	function recompute() {
		var r = root();
		if (!r) return;
		var qty = 0;
		var total = 0;
		r.querySelectorAll('[data-mm-cart-item]').forEach(function (row) {
			var q = parseInt(row.getAttribute('data-qty'), 10) || 0;
			var unit = parseInt(row.getAttribute('data-unit-price'), 10) || 0;
			qty += q;
			total += q * unit;
		});
		r.querySelectorAll('[data-mm-cart-count]').forEach(function (el) {
			roll(el, qty);
		});
		roll(r.querySelector('[data-mm-cart-total]'), money(total));
		var shipping = r.querySelector('[data-mm-cart-shipping]');
		if (shipping) {
			var free = parseInt(shipping.getAttribute('data-free'), 10) || 0;
			var isFree = free > 0 && total >= free;
			var freeEl = shipping.querySelector('[data-mm-cart-shipping-free]');
			var baseEl = shipping.querySelector('[data-mm-cart-shipping-base]');
			if (freeEl) freeEl.hidden = !isFree;
			if (baseEl) baseEl.hidden = isFree;
		}
		/* État vide et pied : bascule OPTIMISTE. Sur une page hors garde de la
		   section (blog, expertise...), le serveur ne peut pas confirmer un
		   panier vidé — la section re-rendue arrive vide et swap() l'ignore.
		   Sans cette bascule, le volet gardait un « Passer au paiement 0,00 »
		   cliquable ; le Liquid rend désormais les deux blocs et l'optimiste
		   choisit. */
		var foot = r.querySelector('[data-mm-cart-foot]');
		var vide = r.querySelector('[data-mm-cart-void]');
		if (foot) foot.hidden = qty === 0;
		if (vide) vide.hidden = qty > 0;

		annonce(phrasePanier(qty, total));
	}

	function paintRow(row) {
		var q = parseInt(row.getAttribute('data-qty'), 10) || 0;
		var unit = parseInt(row.getAttribute('data-unit-price'), 10) || 0;
		roll(row.querySelector('[data-mm-cart-qty]'), q);
		roll(row.querySelector('[data-mm-cart-line-price]'), money(q * unit));
	}

	// Retrait d'une ligne : elle se replie tout de suite, la requête part
	// sans attendre le débounce.
	function removeRow(row) {
		var key = row.getAttribute('data-key');
		clearTimeout(timers[key]);
		row.setAttribute('data-qty', '0');
		row.style.height = row.offsetHeight + 'px';
		// reflow : la hauteur posée doit être peinte avant de transiter vers 0
		void row.offsetHeight;
		row.classList.add('is-removing');
		recompute();
		sendChange(key, 0);
	}

	function stepQty(row, delta) {
		var key = row.getAttribute('data-key');
		var q = (parseInt(row.getAttribute('data-qty'), 10) || 0) + delta;
		if (q <= 0) {
			removeRow(row);
			return;
		}
		row.setAttribute('data-qty', q);
		paintRow(row);
		recompute();
		scheduleChange(key, q);
	}

	/* ---------- événements (délégués : le swap ne casse rien) ---------- */

	document.addEventListener('click', function (event) {
		var toggle = event.target.closest('[data-mm-cart-toggle]');
		if (toggle) {
			if (isOpen) { close(); } else { open(); }
			return;
		}
		if (event.target.closest('[data-mm-cart-close]') || event.target.closest('[data-mm-cart-scrim]')) {
			close();
			return;
		}
		var step = event.target.closest('[data-mm-cart-minus], [data-mm-cart-plus]');
		if (step) {
			var row = step.closest('[data-mm-cart-item]');
			if (row) stepQty(row, step.hasAttribute('data-mm-cart-plus') ? 1 : -1);
			return;
		}
		var remove = event.target.closest('[data-mm-cart-remove]');
		if (remove) {
			var removeItemRow = remove.closest('[data-mm-cart-item]');
			if (removeItemRow && !removeItemRow.classList.contains('is-removing')) removeRow(removeItemRow);
			return;
		}
		if (isOpen && !event.target.closest('[data-mm-cart]')) close();
	});

	document.addEventListener('keydown', function (event) {
		if (event.key === 'Escape') close();
	});

	/* PIÈGE À TABULATION. Le volet se déclare modale : la tabulation ne doit
	   pas s'échapper derrière le voile, où plus rien n'est ni visible ni
	   cliquable. Même geste que la feuille de langue du header
	   (mm-header.js) et que la feuille de filtres. Les cibles sont filtrées
	   sur leur boîte : le pied et l'état vide sont rendus ensemble et bascules
	   par [hidden] (display: none), leurs liens ne doivent pas compter.
	   Clavier uniquement, rien ne change à l'écran. WCAG 2.1.2. */
	function cibles(panel) {
		var liste = panel.querySelectorAll(
			'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
		);
		return Array.prototype.filter.call(liste, function (el) {
			return el.offsetWidth > 0 || el.offsetHeight > 0 || el.getClientRects().length > 0;
		});
	}

	document.addEventListener('keydown', function (event) {
		if (event.key !== 'Tab' || !isOpen) return;
		var r = root();
		var panel = r && r.querySelector('[data-mm-cart-panel]');
		if (!panel) return;
		var liste = cibles(panel);
		if (!liste.length) return;
		var premier = liste[0];
		var dernier = liste[liste.length - 1];
		var actif = document.activeElement;
		if (!panel.contains(actif)) {
			// le focus s'est perdu (swap serveur, clic dans le voile) : on le ramène
			event.preventDefault();
			(event.shiftKey ? dernier : premier).focus({ preventScroll: true });
			return;
		}
		if (event.shiftKey && (actif === premier || actif === panel)) {
			event.preventDefault();
			dernier.focus({ preventScroll: true });
		} else if (!event.shiftKey && actif === dernier) {
			event.preventDefault();
			premier.focus({ preventScroll: true });
		}
	});

	/* ---------- API pour add_to_cart.js ---------- */

	window.mmCartDrawer = {
		exists: function () { return !!root(); },
		sectionId: sectionId,
		open: open,
		refresh: refresh,
		/* Au CLIC d'ajout, avant la requête : ouverture immédiate, et
		   l'optimiste joue — la ligne du même variant grimpe de 1, un
		   nouveau variant pose une ligne d'attente en tête de liste. */
		beginAdd: function (variantId) {
			var r = root();
			if (!r) return;
			open();
			r.classList.add('is-busy'); // tait le message « panier vide »
			addSeq = ++seq;
			var match = variantId && r.querySelector('[data-mm-cart-item][data-variant-id="' + variantId + '"]');
			if (match) {
				match.setAttribute('data-qty', (parseInt(match.getAttribute('data-qty'), 10) || 0) + 1);
				paintRow(match);
				recompute();
			} else {
				var tpl = r.querySelector('[data-mm-cart-skeleton]');
				var items = r.querySelector('[data-mm-cart-items]');
				if (tpl && items) items.prepend(tpl.content.cloneNode(true));
			}
		},
		onAdded: function (sections) {
			var id = sectionId();
			var apply_ = function () {
				var r = root();
				if (r) r.classList.remove('is-busy');
				// swap() a reposé le bloc frais : la région d'annonce est vide,
				// c'est ici qu'on dit ce que contient le panier.
				annonce(synthese());
			};
			if (addSeq !== seq) { apply_(); return; } // une opération plus récente reprendra la main
			if (sections && id && sections[id]) {
				swap(sections[id]);
				apply_();
			} else {
				refresh().then(apply_);
			}
		},
		addFailed: function () {
			var r = root();
			if (r) {
				r.classList.remove('is-busy');
				var skl = r.querySelector('.mm-cart__item--skeleton');
				if (skl) skl.remove();
			}
			// on retombe sur l'état serveur, puis on dit que l'ajout a échoué
			refresh().then(function () { erreur("Cet article n'a pas pu être ajouté au panier. Réessayez ou contactez-nous."); });
		}
	};

	// Au chargement : le calque panier est SORTI de <main>. moon-moon.css.liquid
	// plafonne main à z-index: 1 — tout ce qu'il contient passe sous le header
	// (z 99 en mobile) et le fil d'Ariane, quel que soit son propre z-index.
	// Même parade que le voile du méga menu, déplacé sur <body> pour la même
	// raison. Les écouteurs sont délégués au document : le déplacement ne
	// casse rien, et l'éditeur de thème garde la section à sa place.
	(function () {
		var r = root();
		if (!r) return;
		if (window.Shopify && window.Shopify.designMode) return;
		var sec = r.closest('.shopify-section') || r;
		if (sec.parentElement !== document.body) document.body.appendChild(sec);
	})();
	// Signale la présence du panier à la barre de nav mobile et pose la
	// largeur mesurée de la pilule (script en defer, DOM prêt).
	syncPill();

	// L'état « scrollé » de la pilule, en miroir de la pilule de nav
	// (mm-header.js, même seuil de 24px, même rAF-throttle) : en desktop le
	// verre n'apparaît qu'au scroll, au survol ou volet ouvert — le CSS fait
	// le reste (mm-cart-drawer.css, bloc « même système que la nav »).
	(function () {
		var ticking = false;
		function applyScrolled() {
			ticking = false;
			var r = root();
			if (!r) return;
			var pill = r.querySelector('[data-mm-cart-toggle]');
			if (pill) pill.classList.toggle('is-scrolled', window.scrollY > 24);
		}
		function onScroll() {
			if (ticking) return;
			ticking = true;
			requestAnimationFrame(applyScrolled);
		}
		window.addEventListener('scroll', onScroll, { passive: true });
		applyScrolled();
	})();
})();
